<div style="margin-right: 2em" class="flex-col-grow center-center">
  <div>
    <div>
      {{ columnForm().name }}
    </div>
    @switch (columnForm().type) { @case (TableFieldTypes.TEXT) {
    <div>
      <p>[TXT]</p>
    </div>
    } @case (TableFieldTypes.DECIMAL) {
    <div>
      <p>[1.23]</p>
    </div>
    } @case (TableFieldTypes.INTEGER) {
    <div>
      <p>[123]</p>
    </div>
    } @case (TableFieldTypes.BOOLEAN) {
    <div>
      <p>[Y/N?]</p>
    </div>
    } @case (TableFieldTypes.RADIO) {
    <div>
      <p>[*]</p>
    </div>
    } @case (TableFieldTypes.DROPDOWN) {
    <div>
      <p>[-v-]</p>
    </div>
    } @case (TableFieldTypes.DATERANGE) {
    <div>
      <p>[12.01.2024 - 12.12.2024]</p>
    </div>
    } @case (TableFieldTypes.DATE) {
    <div>
      <p>[ enum: {{ +TableFieldTypes.DATE }} /12.12.2024]</p>
    </div>
    } @case (TableFieldTypes.DATETIME) {
    <div>
      <p>[enum: {{ +TableFieldTypes.DATETIME }} /12.12.2024 12:00]</p>
    </div>
    } @case (TableFieldTypes.CONDITION) {
    <div>
      <p>[ condition enum: {{ +TableFieldTypes.CONDITION }}]</p>
    </div>
    } @case (TableFieldTypes.EXPRESSION) {
    <div>
      <p>[expression enum: {{ +TableFieldTypes.EXPRESSION }}]</p>
    </div>
    } }
  </div>
  <mat-divider />
</div>
